import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "../../Network/API";
import Select from 'react-select'
export default function RmsAlarmFilter({callbackSearch}) {
  const selector_cluster = useSelector((state) => state.clusterReducer);
  const tenants = useSelector((state) => state.tenantReducer)
  const select_rms_alarm_master = useSelector((state) => state.rmsAlarmHistoryReducer)
  const [options, setOption] = useState([])
  const [options2, setOption2] = useState([])
  const [options3, setOption3] = useState([])
  const [resetKey, setResetKey] = useState(0);
  const [cluster_id, setClusterId] = useState('');
  const modalRef1 = useRef()
  const [zone_id, setZoneId] = useState('');
  const [alarm_type_id, setAlarmId] = useState('');
  const dispatch = useDispatch();

  const array_data = {
    'page': 1,
    'site_code': "",
    'tenant_id': "",
    'cluster': "",
    'zone': "",
    'alarm_type': "",
    'start_date': "",
    'end_date': "",
    'filter_type': "",
    'query': "",
    'loadMore': false,
  }

  const searchZone = (e) => {
    setOption2([])
    if (!e) {
      setClusterId('');
      setOption2([])
      return;
    }
  
    setClusterId(e?.value)
   // console.log("Cluster ID:", e.value);
    API.get(`/v1/oauth/ajax_cluster_zone/${e.value}`).then((response) => {
      setOption2(response.data.data.zone)
    }).catch((error) => {

    });
  }

  const searchZoneSite = (e) => {

    if (!e) {
      setZoneId('');
      return;
    }
    setZoneId(e?.value)
  }

  const searchAlarmType = (e) => {

    if (!e) {
      setAlarmId('');
      return;
    }
     
    setAlarmId(e?.value)
  }


  useEffect(() => {
    if (selector_cluster?.data && Array.isArray(selector_cluster.data)) {
      const newOptions = selector_cluster?.data?.map(item => ({
        value: item.id.toString(), // Assuming you want the ID as a string
        label: item.name
      }));
      setOption(newOptions);
    } else {
      setOption([]); // Optional: clear options if data is not available
    }
  }, [selector_cluster]);

  const handleSubmit = (event) => {
    event.preventDefault();
     console.log("cluster="+alarm_type_id)
    array_data.site_code = event.target.siteId.value;
    array_data.cluster = cluster_id;
    array_data.zone = zone_id;
    array_data.alarm_type = alarm_type_id;
    array_data.filter_type = event.target.filter_type.value;
    array_data.tenant_id = event.target.tenant.value;
    array_data.start_date = event.target.from_date.value;
    array_data.end_date = event.target.to_date.value;
    array_data.page = 1;

    callbackSearch(array_data)
  }

  const resetForm=()=>{
        array_data.site_code = '';
    array_data.cluster = '';
    array_data.zone = '';
    array_data.alarm_type = '';
    array_data.filter_type = '';
    array_data.tenant_id = '';
    array_data.start_date = '';
    array_data.end_date = '';
    array_data.page = 1;

    callbackSearch(array_data)
  }


  return (
    <>
      <div className="dropdown d-inline-block">
        <button className="btn btn-info rounded-0 text-white"
          type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa-solid fa-filter"></i> Filter
        </button>

        <div className="dropdown-menu p-2 shadow" aria-labelledby="dropdownMenuButton2" onClick={(e) => e.stopPropagation()}>
          <div style={{ width: '400px' }}>

            <h5 className='border-bottom pb-2 fw-bold mb-2'>Quick Filter</h5>
            <form ref={modalRef1} onSubmit={handleSubmit} id="add_country_form">

            {/* //alarm time asc/desc */}

            <div className='row'>
              <div className="form-group  mb-2 col-md-12">
                <label className="form-label fs-7">Site ID</label>
                <input type="text" name="siteId" className="form-control form-control-sm" placeholder="Search by site id" />
              </div>
              <div className="form-group  mb-2 col-md-6">
                <label className="form-label fs-7">Cluster</label>
                <Select key={resetKey} onChange={searchZone} name="cluster" isClearable closeMenuOnSelect={true} options={options} />

              </div>
              <div className="form-group mb-2 col-md-6">
                <label className="form-label fs-7">Zone</label>
                <Select key={resetKey} onChange={searchZoneSite} name="zone" isClearable closeMenuOnSelect={true} options={options2} />

              </div>


              <div className="form-group mb-2 col-md-6">
                <label className="form-label fs-7">Tenant</label>
                <select name="tenant" className='form-select form-select-sm'>
                  <option value={``}>All Tenant</option>
                  {tenants?.data?.length > 0 && tenants?.data?.map((tenant, indexI) => (
                    <option value={tenant.id}>{tenant.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group mb-2 col-md-6">
                <label className="form-label fs-7">Alarm Name</label>
                <Select key={resetKey} onChange={searchAlarmType} name="alarm_type" isClearable closeMenuOnSelect={true} options={select_rms_alarm_master?.alarm_master} />

              </div>
            </div>
            <div className="form-group mb-2">
              <label className="form-label fs-7">Filter Types</label>
              <select name="filter_type" className='form-select form-select-sm'>
                <option value={``}>All</option>
                <option value={`1`}>Active Alarms</option>
                <option value={`2`}>Long Duration Active Alarms</option>
                <option value={`3`}>Abnormal Alarms</option>
                <option value={`4`}>Unusual Alarm Types</option>
                <option value={`5`}>Critical Alarms Only</option>
                <option value={`6`}>Recently Closed Alarms</option>
                <option value={`7`}>Off-Hour Alarms</option>
                <option value={`8`}>High Alarm Density</option>
                {/* <option value={`8`}>Top Frequent Alarms</option> */}
              </select>
            </div>
            <div className="form-group mb-2">
              <label className="form-label fs-7">Date</label>
              <div className="input-group input-group-sm">
                <input name="from_date" type="date" class="form-control" placeholder="" />
                <input name="to_date" type="date" class="form-control" placeholder="" />
              </div>

            </div>


            <div className="card-footer mt-2 mb-2">
<button type="submit" className="btn btn-success btn-sm me-2">Apply Filter</button>
            <button onClick={()=>resetForm()} type="button" className="btn btn-danger btn-sm">Reset Filter</button>
            </div>
</form>
          </div>



        </div>
      </div>
    </>
  )
}